/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type CustomerEmailCodeLoginVariables = Types.Exact<{
  emailToken: Types.Scalars['String']
}>

export type CustomerEmailCodeLogin = {
  __typename: 'Root'
  customerEmailCodeLogin: {
    __typename: 'CustomerEmailCodeLoginPayload'
    redirectTo: string | null
    customer: {
      __typename: 'Customer'
      id: number
      authenticationToken: string
      email: string
      completeProfile: boolean
      anonymous: boolean
      phone: any | null
      firstName: string | null
      lastName: string | null
    } | null
    errors: Array<{
      __typename: 'UserError'
      fullMessage: string | null
      key: string | null
      message: string | null
    }> | null
  } | null
}

export const CustomerEmailCodeLoginDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CustomerEmailCodeLogin' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'emailToken' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customerEmailCodeLogin' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emailToken' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'emailToken' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authenticationToken' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completeProfile' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'anonymous' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'redirectTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullMessage' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode
export type CustomerEmailCodeLoginMutationFn = Apollo.MutationFunction<
  CustomerEmailCodeLogin,
  CustomerEmailCodeLoginVariables
>

/**
 * __useCustomerEmailCodeLogin__
 *
 * To run a mutation, you first call `useCustomerEmailCodeLogin` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerEmailCodeLogin` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerEmailCodeLogin, { data, loading, error }] = useCustomerEmailCodeLogin({
 *   variables: {
 *      emailToken: // value for 'emailToken'
 *   },
 * });
 */
export function useCustomerEmailCodeLogin(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CustomerEmailCodeLogin,
    CustomerEmailCodeLoginVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CustomerEmailCodeLogin,
    CustomerEmailCodeLoginVariables
  >(CustomerEmailCodeLoginDocument, options)
}
export type CustomerEmailCodeLoginHookResult = ReturnType<
  typeof useCustomerEmailCodeLogin
>
export type CustomerEmailCodeLoginMutationResult =
  Apollo.MutationResult<CustomerEmailCodeLogin>
export type CustomerEmailCodeLoginMutationOptions = Apollo.BaseMutationOptions<
  CustomerEmailCodeLogin,
  CustomerEmailCodeLoginVariables
>
